// extracted by mini-css-extract-plugin
export default {"container":"Testimonial_container__HgE-D","content":"Testimonial_content__mxJy7","carousel":"Testimonial_carousel__+vz9N","title":"Testimonial_title__XNhib"};